import React from "react";
export function Footer() {
  return <footer className="w-full border-t border-line bg-navy" data-id="element-141" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-4xl px-5 pb-32 pt-12 text-center sm:px-8 md:pb-16" data-id="element-142" data-mp="3gfiuujlrgden">
        <p className="font-serif text-2xl font-bold text-gold" data-id="element-143" data-mp="32oe303omwpev">HOF CLINICAL BLUEPRINT™</p>
        <p className="mt-1 text-sm text-muted" data-id="element-144" data-mp="36p6buvtlgsam">Created by Dr. Michael Carter</p>

        <div className="mt-8 text-left" data-id="element-145" data-mp="36n3axgqwler4">
          <h2 className="text-sm font-bold uppercase tracking-wider text-cream" data-id="element-146" data-mp="3ues7xaeo6ree">Important Educational Disclaimer</h2>
          <div className="mt-3 space-y-3 text-xs leading-relaxed text-muted" data-id="element-147" data-mp="37fvf8oqf24t">
            <p data-id="element-148" data-mp="3lf57aqtrlpme">
              HOF CLINICAL BLUEPRINT™ is an educational reference collection intended for appropriately qualified
              professionals. It does not confer professional qualifications, authorization to perform procedures, or
              certification in any clinical specialty.
            </p>
            <p data-id="element-149" data-mp="2ez1joazlf0yu">
              The materials do not replace formal education, supervised training, individualized patient assessment,
              professional judgment, or current clinical guidelines and emergency protocols. Clinical decisions must be
              made by qualified practitioners in accordance with applicable laws, regulations, evidence, and the
              individual patient’s circumstances.
            </p>
            <p data-id="element-150" data-mp="3qapwx67vh2kp">Any templates or checklists must be adapted to the practitioner’s professional scope and local requirements.</p>
          </div>
        </div>

        <p className="mt-8 text-xs text-muted/70" data-id="element-151" data-mp="32w3rvu3xgbu">© 2026 HOF CLINICAL BLUEPRINT™. All rights reserved.</p>
      </div>
    </footer>;
}